export default function isScrolled() {
   const navbarClasses = ['.navbar.fixed-top', '.header.fixed-top', '.navbar'];
   const navbar = document.querySelector(navbarClasses.join(', ')); // Combine classes for selection
   const navbarHeight = navbar?.offsetHeight || 0; // Handle cases where navbar might not exist
   const firstScroll = 5;

   let previousScrollY = 0; // Track previous scroll position
   if (navbar) {
      const handleScroll = () => {
         const currentScrollY = window.scrollY;
         const isScrolledDown = currentScrollY > navbarHeight;
         //const contactBar = document.querySelector('.contact-bar');
         const scrollTop = document.querySelector('.scroll-top');

         // Update classes based on scroll direction
         document.body.classList.toggle('is-scrolled', isScrolledDown);

         // Add "scrolled-up" only on upward scroll
         if (currentScrollY < previousScrollY) {
            document.body.classList.add('scrolled-up');
         } else {
            document.body.classList.remove('scrolled-up');
         }
         if (currentScrollY > firstScroll) {
            document.body.classList.add('scrolled');
            //contactBar.classList.add('show');
            scrollTop.classList.add('show');
         } else {
            document.body.classList.remove('scrolled');
            //contactBar.classList.remove('show');
            scrollTop.classList.remove('show');
         }

         previousScrollY = currentScrollY;
      };

      // Add event listener only once
      window.addEventListener('scroll', handleScroll);
   }
}
